import React, { FC } from 'react';
import Typography from '@mui/material/Typography';

const ExFormLabel= ({ label }) => (
  <Typography>{`${label ?? ''}`}</Typography>
);

export default ExFormLabel;
